import { getValidAccessToken } from "../services/oauthservice";
import { encryptRSA } from '../services/encrypt.js';

// src/utils/apiLogger.js
export const createJourneyLog = async (requestData) => {
    try {
        const encrypted = await encryptRSA({ ...requestData });
        const token = await getValidAccessToken();
        const response = await fetch(
            `${process.env.REACT_APP_DIC_ADMIN_API}/v1/logs/journey-logs`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ encrypted }) 
            }
        );

        const data = await response.json();
        return data; // return success or error from API
    } catch (error) {
        console.error("Error creating API log:", error);
        return { success: false, message: error.message };
    }
};

export const updateJourneyLog = async (requestData) => {
    try {
        const token = await getValidAccessToken();
        const encrypted = await encryptRSA({ ...requestData });
        const response = await fetch(
            `${process.env.REACT_APP_DIC_ADMIN_API}/v1/logs/journey-logs`,
            {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ encrypted }),
            }
        );

        const data = await response.json();
        return data; // return success or error from API
    } catch (error) {
        console.error("Error creating API log:", error);
        return { success: false, message: error.message };
    }
};